import { api } from './api';

/** GET /workspaces/me/publishing (Task 1.5). */
export interface PublishingPauseStatus {
  paused: boolean;
  pausedAt: string | null;
  pausedBy: string | null;
  reason: string | null;
  /** Posts waiting to publish (scheduled or awaiting approval): what a pause holds. */
  held: number;
  /** Scheduled posts whose time passed while paused: resuming asks what to do with them. */
  missed: number;
}

export type MissedPostsChoice = 'publish_now' | 'to_drafts';

/** Pause all publishing for the brand, and resume it. */
export const publishingService = {
  async status(): Promise<PublishingPauseStatus> {
    const res = await api.get<PublishingPauseStatus>('/workspaces/me/publishing');
    return res.data;
  },
  async pause(reason?: string): Promise<PublishingPauseStatus> {
    const res = await api.post<PublishingPauseStatus>('/workspaces/me/publishing/pause', reason ? { reason } : {});
    return res.data;
  },
  async resume(missed?: MissedPostsChoice): Promise<PublishingPauseStatus> {
    const res = await api.post<PublishingPauseStatus>('/workspaces/me/publishing/resume', missed ? { missed } : {});
    return res.data;
  },
};
